var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgElIconPremium2 = function SvgElIconPremium2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFD164",
    d: "M13.903 8.198 10.8 2.392 7.698 8.198 1.801 4.842l3.035 9.866a.31.31 0 0 0 .297.217h11.335a.31.31 0 0 0 .297-.217L19.8 4.842l-5.897 3.356Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FBC139",
    d: "M7.698 8.198 1.801 4.842l3.035 9.867a.31.31 0 0 0 .297.216h3.349l-.784-6.727Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFD164",
    d: "m6.292 15.892.297 1.512c.039.194.154.327.286.327h9.103c.131 0 .247-.133.285-.327l.298-1.512H6.292Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#FBC139",
    d: "m5.172 15.892.405 1.512c.052.194.21.327.389.327h2.847l-.28-1.839H5.171Z"
  })));
};
export default SvgElIconPremium2;